import type { ComponentProps } from 'react';
import { cn } from '../lib/cn.ts';
import { Card as CardPrimitive } from '../primitives/card.tsx';

export interface CardProps extends ComponentProps<'div'> {
  /** Hover edge for clickable cards. */
  interactive?: boolean;
  padded?: boolean;
}

/**
 * A bordered surface on the shadcn Card. Only for mixed content in dashboard tiles, never as a
 * replacement for a list (components.md). Use Panel when it has a title.
 */
export function Card({ interactive, padded = true, className, ...rest }: CardProps) {
  return (
    <CardPrimitive
      className={cn(
        'block gap-0 py-0',
        padded && 'p-(--space-inset-card)',
        interactive && 'transition-colors duration-(--duration-fast) hover:border-border-strong hover:bg-raised',
        className,
      )}
      {...rest}
    />
  );
}
